import http from '../common/http';
import { GeneralInfoPatchRequestData } from '../components/Onboarding/Pages/GeneralInfo/generalInfoRequest';
import { ServicesPatchRequestData } from '../components/Onboarding/Pages/Services/servicesRequest';
import { MediaPatchRequestData } from '../components/Onboarding/Pages/Media/mediaRequest';
import { AdditionalInfoPathRequestData } from '../components/Onboarding/Pages/AdditionalInfo/additionalInfoRequest';
import { ConfigurationPatchRequestData } from '../components/Onboarding/Pages/Configuration/configurationRequest';
import OnboardingResponse from '../common/interfaces/Onboarding/OnboardingResponse';

class OnboardingService {
  getOnboarding(id: string): Promise<OnboardingResponse> {
    return http.get(`/onboardings/${id}`).then(response => response.data);
  }

  confirmOnboardingGeneralInfo(id: string, data: GeneralInfoPatchRequestData) {
    return http.patch(`/onboardings/${id}`, { generalInfo: data });
  }

  confirmOnboardingServices(id: string, data: ServicesPatchRequestData[]) {
    return http.patch(`/onboardings/${id}`, { services: data });
  }

  confirmOnboardingMedia(id: string, data: MediaPatchRequestData) {
    return http.patch(`/onboardings/${id}`, { media: data });
  }

  confirmOnboardingAdditionalInfo(id: string, data: AdditionalInfoPathRequestData) {
    return http.patch(`/onboardings/${id}`, { additionalInfo: data });
  }

  confirmOnboardingConfiguration(id: string, data: ConfigurationPatchRequestData) {
    return http.patch(`/onboardings/${id}`, { configuration: data });
  }

  getDnsSettings(domain: string) {
    return http.get(`/dns-info?hostname=${encodeURIComponent(domain)}`);
  }

  setUserOwnDomain(domain: string) {
    return http.post(`/users/own-domain-name`,{"ownDomainName": `${encodeURIComponent(domain)}`});
  }

  //todo bad response from backend (it's not a minisite ip)
  getMinisiteIpAddress() {
    return http.get(`/status`);
  }
}

export default new OnboardingService();
